import ApiClient from '@services/ApiClient/ApiClient'

export default new ApiClient({
  baseUrl: process.env.API_URL
})



// WEBPACK FOOTER //
// ./src/services/ApiClient/index.js